import styled from 'styled-components';
export const EmptyStateContainer = styled.div.withConfig({
  displayName: "EmptyStateContainer",
  componentId: "cak9bb-0"
})(["padding-bottom:2rem;"]);